import { useQuery } from '@ts-core/lib/apollo';

import { getAcademyQuery, GetAcademyQueryResult } from '../graphql/queries/getAcademyQuery';

import { Academy } from '../types';

interface AcademyHookOutput {
  academy?: Academy;
  loading: boolean;
}

export default function useAcademy(): AcademyHookOutput {
  const { data, loading } = useQuery<GetAcademyQueryResult>(getAcademyQuery);

  return {
    academy: data?.academy,
    loading,
  };
}
